import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import DotIcon from '@material-ui/icons/FiberManualRecord';
import { StyledText } from './StyledText';

interface IndustryBulletProps {
  industry: string
  padding?: any
  variant?: any
  color?: any
}

const IndustryBullet: React.FC<IndustryBulletProps> = ({
  industry,
  padding = '10px',
  variant = 'subtitle1',
  color = 'textSecondary'
}) => (
  <Box display='flex' justifyContent='center' alignItems='center' width='fit-content' padding={padding}>
    <DotIcon style={{ height: 10, width: 10, margin: '0 10px 0 0' }} />
    <StyledText
      className='industryItemDescription'
      variant={variant}
      color={color}
      component='div'
      style={{ textTransform: 'capitalize' }}
    >
      {industry}
    </StyledText>
  </Box>
);

export default IndustryBullet;
